module.exports = __webpack_public_path__ + "media/images/direct_message_empty-f821f5b8.svg";